import { parse } from 'query-string';
import parsePath from '../utils/parsePath';
/**
 * 通过url添加参数扩充body参数
 *
 * @example
 * url http://localhost:3000/#/ticket/updateDetail?rp=orderNo-S123&in=queryOrderTickets
 * request url http://localhost:3000/EMP/queryOrderTickets
 * request body { orderNo: S123 }
 *
 * @param {AxiosRequestConfig} config axios 请求 config
 * @returns {AxiosRequestConfig}
 */
export default function enhanceRequest(config) {
    var _parsePath = parsePath(window.location.href);
    var _url = parse(_parsePath.search);
    if (config.url.includes(_url.in)) {
        if (_url.in && _url.rp) {
            var arr = _url.rp.split('-');
            config.data[arr[0]] = arr[1];
        }
    }
    return config;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/request/enhanceRequest.js
// module id = null
// module chunks = 